import {
  UserInfoUpdateType,
  ViewState,
} from '../components/MobilePlanCards/types';

export interface ChangePlanReducer {
  userInfoUpdate: UserInfoUpdateType;
  showActionLayer: boolean;
  viewState: ViewState;
}

export const initialState: ChangePlanReducer = {
  showActionLayer: false,
  userInfoUpdate: {
    accounts: [],
    eligibleLines: [],
    redirect: null,
    selectedAccount: '',
  },
  viewState: ViewState.ManageAccount,
};

export enum ChangePlanActionTypes {
  SetManageAccounts = 'SET_MANAGE_ACCOUNTS',
  SetManageLines = 'SET_MANAGE_LINES',
  SetChangeAccount = 'SET_CHANGE_ACCOUNT',
  CloseActionLayer = 'CLOSE_ACTION_LAYER',
}

export interface UpdateActionLayer {
  type: ChangePlanActionTypes;
  payload?: UserInfoUpdateType;
}

export type ChangePlanAction = UpdateActionLayer;

export const changePlanReducer = (
  state: ChangePlanReducer,
  action: ChangePlanAction,
): ChangePlanReducer => {
  switch (action.type) {
    case ChangePlanActionTypes.SetManageAccounts:
      return {
        ...state,
        showActionLayer: true,
        viewState: ViewState.ManageAccount,
        userInfoUpdate: {
          ...state.userInfoUpdate,
          ...action.payload,
        },
      };

    case ChangePlanActionTypes.SetManageLines:
      return {
        ...state,
        showActionLayer: true,
        viewState: ViewState.ManageLines,
        userInfoUpdate: {
          ...state.userInfoUpdate,
          ...action.payload,
        },
      };

    case ChangePlanActionTypes.SetChangeAccount:
      return {
        ...state,
        showActionLayer: true,
        viewState: ViewState.ManageAccount,
        userInfoUpdate: {
          ...state.userInfoUpdate,
          selectedAccount: '',
        },
      };

    case ChangePlanActionTypes.CloseActionLayer:
      return {
        ...state,
        showActionLayer: false,
        viewState: ViewState.ManageAccount,
        userInfoUpdate: {
          accounts: [],
          eligibleLines: [],
          redirect: null,
          selectedAccount: '',
        },
      };

    default:
      return state;
  }
};
